import { render, staticRenderFns } from "./InventoryItemPurchaseFilter.vue?vue&type=template&id=3a74d542&scoped=true&"
import script from "./InventoryItemPurchaseFilter.vue?vue&type=script&lang=js&"
export * from "./InventoryItemPurchaseFilter.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a74d542",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCheckbox } from 'vuetify/lib/components/VCheckbox';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VCheckbox,VTextField})
